(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

var MEGA_MENU_CLOSE_DURATION = 280;

if (window.innerWidth > 990) {

  function syncTransparentHeader() {
    var h = document.querySelector('.header--transparent-home');
    if (!h) return;
    var anyClicked = Array.from(document.querySelectorAll('details.mega-menu')).some(function (m) { return m._isClickedOpen; });
    if (anyClicked) {
      h.setAttribute('data-megamenu-clicked', '');
    } else {
      h.removeAttribute('data-megamenu-clicked');
    }
  }

  function closeMenu(menu, animated) {
    if (animated === undefined) animated = true;

    if (animated && menu.hasAttribute('open') && !menu._closing) {
      menu._closing = true;
      menu.classList.add('is-closing');
      menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      menu.dataset.openedBy = '';
      menu._isClickedOpen = false;

      setTimeout(function () {
        menu.removeAttribute('open');
        menu.classList.remove('is-closing');
        menu._closing = false;
        syncTransparentHeader();
      }, MEGA_MENU_CLOSE_DURATION);
    } else {
      menu.classList.remove('is-closing');
      menu.removeAttribute('open');
      menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      menu.dataset.openedBy = '';
      menu._isClickedOpen = false;
      menu._closing = false;
      syncTransparentHeader();
    }
  }

  function openMenu(menu, by) {
    menu.setAttribute('open', '');
    menu.classList.remove('is-closing');
    menu.querySelector('summary').setAttribute('aria-expanded', 'true');
    menu.dataset.openedBy = by;
    if (by === 'click') menu._isClickedOpen = true;
    syncTransparentHeader();
  }

  document.querySelectorAll('details.mega-menu').forEach(function (menu) {
    var summary = menu.querySelector('summary');
    menu._isClickedOpen = false;
    menu._hoverCloseTimer = null;
    menu._closing = false;

    menu.addEventListener('mouseenter', function () {
      clearTimeout(menu._hoverCloseTimer);
      if (!menu._isClickedOpen) {
        document.querySelectorAll('details.mega-menu').forEach(function (other) {
          if (other !== menu && other.hasAttribute('open') && !other._isClickedOpen && !other._closing) {
            closeMenu(other);
          }
        });
        openMenu(menu, 'hover');
      }
    });

    menu.addEventListener('mouseleave', function () {
      if (!menu._isClickedOpen && menu.dataset.openedBy === 'hover') {
        menu._hoverCloseTimer = setTimeout(function () {
          closeMenu(menu);
        }, 120);
      }
    });

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearTimeout(menu._hoverCloseTimer);

      if (menu._isClickedOpen) {
        closeMenu(menu, true);
      } else {
        document.querySelectorAll('details.mega-menu').forEach(function (other) {
          if (other._isClickedOpen) closeMenu(other, true);
        });
        openMenu(menu, 'click');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('details.mega-menu')) {
      document.querySelectorAll('details.mega-menu').forEach(function (menu) {
        if (menu._isClickedOpen) closeMenu(menu, true);
      });
    }
  });

  var scrollTimer = null;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      document.querySelectorAll('details.mega-menu').forEach(function (menu) {
        if (menu._isClickedOpen) closeMenu(menu, true);
      });
    }, 50);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('details.mega-menu').forEach(function (menu) {
        if (menu._isClickedOpen) closeMenu(menu, true);
      });
    }
  });
}
document.addEventListener("DOMContentLoaded", function() {
  const header = document.querySelector(".header--transparent-home");
  if (!header) return;

  window.addEventListener("scroll", function() {
    if (window.scrollY > 50) {
      header.classList.add("scrolled-past-header");
    } else {
      header.classList.remove("scrolled-past-header");
    }
  });
});
// ── Sticky Header Web Component ─────────────────────────
class StickyHeader extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
      else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal?.close?.(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
